import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
export const lionSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  .game-icon-no-label {
    .game-icon {
      width: 304px;
      height: 80px;
      margin-bottom: 32px;

      ${chroma.mediaQueries.tabletDown} {
        width: 180px;
        height: 40px;
        margin-bottom: 24px;
      }

      .game-icon-img {
        width: 100%;
        height: auto;
      }
    }
  }

  .game-icon-and-label {
    .game-icon {
      width: 40px;
      height: 40px;
      margin-right: 16px;

      ${chroma.mediaQueries.tabletDown} {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }

      .game-icon-img {
        width: 100%;
        height: auto;
      }
    }

    .game-label-text {
      ${chroma.typography.body1};
      font-weight: 400;
    }
  }
`;
//# sourceMappingURL=index.js.map